<!-- SearchAd.vue -->

<template>
    <div class="search-ad-filters-section tsw-parent mt-2">

        <!-- For test only -->
        <!-- <div>
            <div>Per page: {{ this.perPage }}</div>
            <div>Page number: {{ this.page }}</div>
        </div> -->

        <div class="filters-clear-wrapper mb-4" :class="{'show-filter': this.show_clear_filter}" >
            <a class="pf-text-link" href="#" @click="handleClearFilter"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 348.333 348.333" class="vue-treeselect__x" style="color: #A4CC5E;fill: #A4CC5E;"><path d="M336.559 68.611L231.016 174.165l105.543 105.549c15.699 15.705 15.699 41.145 0 56.85-7.844 7.844-18.128 11.769-28.407 11.769-10.296 0-20.581-3.919-28.419-11.769L174.167 231.003 68.609 336.563c-7.843 7.844-18.128 11.769-28.416 11.769-10.285 0-20.563-3.919-28.413-11.769-15.699-15.698-15.699-41.139 0-56.85l105.54-105.549L11.774 68.611c-15.699-15.699-15.699-41.145 0-56.844 15.696-15.687 41.127-15.687 56.829 0l105.563 105.554L279.721 11.767c15.705-15.687 41.139-15.687 56.832 0 15.705 15.699 15.705 41.145.006 56.844z"></path></svg>  <span>Cancella tutto</span></a>
        </div>
        <div class="filters-title-wrapper  mb-4" :class="{'d-none': this.show_clear_filter}" >
            <span class="font-14pt"><b>Ricerca avanzata</b></span>
        </div>
      
        <section class="search-filter-group location-provinces mt-0">

            <div class="filters-heading">
                <span class="form-section-title pf-title mt-0">Località </span>
            </div>

            <div class="location-filter-wrapper">
                <!-- check documentation: https://vue-treeselect.js.org/#more-features -->
                <treeselect 
                  :multiple="true"
                  v-model="filter_provinces" 
                  :options="filter_provinces_options" 
                  :searchable="true"
                  :appendToBody="true"
                  placeholder="Cerca Regione/Provincia"
                  value-consists-of="BRANCH_PRIORITY"
                  @input="applyProvinceRegion"
                  :clear-on-select="true"
                  noResultsText="Nessun risultato..."
                  :disabled="filter_abroad_only ? true : null"
                />
            </div>

        </section>

        <section class="search-filter-group abroad-only mt-2">
            <div class="pf-field">
                <p class="remember-label">
                    <input type="checkbox" name="abroad_only" id="abroad_only" :value="true"
                                    v-on:focus="clearErrors" v-model="filter_abroad_only" v-on:change="applyFilters">
                    <label for="abroad_only">{{ this.abroad_only_text }}</label>
                </p>
            </div>
        </section>

        <section  class="search-filter-group roles-filter mt-4">

            <div class="filters-heading">
                <span class="form-section-title pf-title">Ruolo</span>
            </div>

            <div class="list-filter-wrapper">
                <div class="roles_tennis_wrapper">
                    <span class="tp-head mb-0"><b>Tennis</b></span>
                    <div class="pf-field ps-2">
                        <p class="remember-label">
                            <input type="checkbox" name="role" id="role_1" value="1"  v-model="filter_roles"
                                        v-on:focus="clearErrors"  v-on:change="applyFilters">
                            <label for="role_1">Maestro di tennis</label>
                        </p>
                        <p class="remember-label">
                            <input type="checkbox" name="role" id="role_2" value="2" v-model="filter_roles"
                                                        v-on:focus="clearErrors"   v-on:change="applyFilters"><label
                                for="role_2">Sparring partner</label>
                        </p>
                        <p class="remember-label">
                            <input type="checkbox" name="role" id="role_4" value="3" v-model="filter_roles"
                                                        v-on:focus="clearErrors"   v-on:change="applyFilters">
                                <label for="role_4">Giocatore di tennis</label>
                        </p>
                        <p class="remember-label">
                            <input type="checkbox" name="role" id="role_3" value="4"
                                                        v-on:focus="clearErrors" v-model="filter_roles" v-on:change="applyFilters" >
                            <label for="role_3">Preparatore fisico</label>
                        </p>
                        <p class="remember-label">
                            <input type="checkbox" name="role" id="role_5" value="5"
                                                        v-on:focus="clearErrors" v-model="filter_roles"   v-on:change="applyFilters">
                            <label for="role_5">Incordatore</label>
                        </p>
                    </div>
                </div>
                <div class="roles_tennis_wrapper mt-2">
                    <span class="tp-head mb-0"><b>Padel</b></span>
                    <div class="pf-field ps-2">
                        <p class="remember-label">
                            <input type="checkbox" name="role" id="role_6" value="6"
                                            v-on:focus="clearErrors" v-model="filter_roles" v-on:change="applyFilters">
                            <label for="role_6">Maestro di padel</label>
                        </p>
                        <p class="remember-label">
                            <input type="checkbox" name="role" id="role_7" value="7"
                                                        v-on:focus="clearErrors" v-model="filter_roles" v-on:change="applyFilters">
                                <label for="role_7">Giocatore di padel</label>
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section class="search-filter-group certification-filter mt-4" v-if="filter_roles.includes('1') || filter_roles.includes('2') || filter_roles.includes('4') || filter_roles.includes('5') || filter_roles.includes('6')">
            <div class="filters-heading">
                <span class="form-section-title pf-title">Certificazioni</span>
            </div>

            <!-- Tennis -->
            <div class="tennis-certification-wrapper">

                <!-- Maestro di tennis -->
                <div class="certification-filter-group" v-if="filter_roles.includes('1') || filter_roles.includes('2')">
                    <span class="tp-head filter-group-head">
                        {{(filter_roles.includes('1') && filter_roles.includes('2'))?'Maestro di tennis / Sparring partner'
                        :(filter_roles.includes('1'))? "Maestro di tennis":(filter_roles.includes('2'))? 'Sparring partner':"" }}
                    </span>
                    <div class="certification-filter-inner">
                        <div class="d-flex">
                            <span class="tp-head d-flex align-items-center gap-5">
                                <!-- <img src="/img/website/favicon.png" width="20px" />  -->
                                <span class="c-title"><b>FITP</b></span>
                            </span>
                        </div>
                        <div class="pf-field ps-2">
                            <p class="remember-label">
                                <input type="checkbox" name="tennis_cert_coach_sparring_fitp" id="tccsp_fitp_1" value="1" 
                                v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_coach_sparring_fitp"   v-on:change="applyFilters">
                                <label for="tccsp_fitp_1">IS 1° Grado</label></p>
                            <p class="remember-label">
                                <input type="checkbox" name="tennis_cert_coach_sparring_fitp" id="tccsp_fitp_2" value="2" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_coach_sparring_fitp"   v-on:change="applyFilters">
                                <label for="tccsp_fitp_2">IS 2° Grado</label></p>
                            <p class="remember-label"><input type="checkbox" name="tennis_cert_coach_sparring_fitp" id="tccsp_fitp_3" value="3" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_coach_sparring_fitp"  v-on:change="applyFilters"  ><label
                                    for="tccsp_fitp_3">Maestro Nazionale</label></p>
                            <p class="remember-label"><input type="checkbox" name="tennis_cert_coach_sparring_fitp" id="tccsp_fitp_4" value="4" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_coach_sparring_fitp" v-on:change="applyFilters"  ><label
                                    for="tccsp_fitp_4">Tecnico Nazionale</label></p>
                        </div>
                        <div class="d-flex w-100 pt-2" >
                            <span class="tp-head d-flex align-items-center gap-5">
                                <!-- <img src="/img/website/favicon.png" width="20px" />  -->
                                <span class="c-title"><b>PTR</b></span>
                            </span>
                        </div>
                        <div class="pf-field ps-2">
                            <p class="remember-label"><input type="checkbox" name="tennis_cert_coach_sparring_ptr" id="ctr_ptr_1" value="1" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_coach_sparring_ptr"   v-on:change="applyFilters"><label
                                    for="ctr_ptr_1">Associate Instructor</label></p>
                            <p class="remember-label"><input type="checkbox" name="tennis_cert_coach_sparring_ptr" id="ctr_ptr_2" value="2" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_coach_sparring_ptr"   v-on:change="applyFilters"><label
                                    for="ctr_ptr_2">Instructor</label></p>
                            <p class="remember-label"><input type="checkbox" name="tennis_cert_coach_sparring_ptr" id="ctr_ptr_3" value="3" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_coach_sparring_ptr"   v-on:change="applyFilters"><label
                                    for="ctr_ptr_3">Professional</label></p>
                        </div>
                        <div class="d-flex w-100 pt-2" >
                            <span class="tp-head d-flex align-items-center gap-5">
                                <!-- <img src="/img/website/favicon.png" width="20px" />  -->
                                <span class="c-title"><b>MTMCA</b></span>
                            </span>
                        </div>
                        <div class="pf-field ps-2">
                            <p class="remember-label">
                                <input type="checkbox" name="tennis_cert_coach_sparring_mtmca" id="ctr_mtmca_1" value="1" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_coach_sparring_mtmca"   v-on:change="applyFilters"><label
                                    for="ctr_mtmca_1">International Coach Tennis Teacher</label></p>
                            <p class="remember-label">
                                <input type="checkbox" name="tennis_cert_coach_sparring_mtmca" id="ctr_mtmca_2" value="2" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_coach_sparring_mtmca"   v-on:change="applyFilters"><label
                                    for="ctr_mtmca_2">International Coach Tennis Teaching Professional</label></p>
                        </div>
                    </div>
                </div>


                <!-- Preparatore fisico -->
                <div class="certification-filter-group" v-if="filter_roles.includes('4')">
                    <span class="tp-head filter-group-head">Preparatore fisico</span>
                    <div class="certification-filter-inner">
                        <div class="d-flex">
                            <span class="tp-head d-flex align-items-center gap-5">
                                <!-- <img src="/img/website/favicon.png" width="20px" />  -->
                                <span class="c-title"><b>FITP</b></span>
                            </span>
                        </div>
                        <div class="pf-field ps-2">
                            <p class="remember-label">
                                <input type="checkbox" name="tennis_cert_physicaltrainer_fitp" id="ctr_pf_1" value="1" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_physicaltrainer_fitp"   v-on:change="applyFilters"><label
                                    for="ctr_pf_1">1° Grado</label></p>
                            <p class="remember-label">
                                <input type="checkbox" name="tennis_cert_physicaltrainer_fitp" id="ctr_pf_2" value="2" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_physicaltrainer_fitp" v-on:change="applyFilters"  ><label
                                    for="ctr_pf_2">2° Grado</label></p>
                        </div>
                    </div>
                </div>


                <!-- Incordatore -->
                <div class="certification-filter-group" v-if="filter_roles.includes('5')">
                    <span class="tp-head filter-group-head">Incordatore</span>
                    <div class="certification-filter-inner">
                        <div class="d-flex">
                            <span class="tp-head d-flex align-items-center gap-5">
                                <!-- <img src="/img/website/favicon.png" width="20px" />  -->
                                <span class="c-title"><b>FITP</b></span>
                            </span>
                        </div>
                        <div class="pf-field ps-2">
                            <p class="remember-label"><input type="checkbox" name="tennis_cert_stringer_fitp" id="ctr_pf_fitp_1" value="1" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_stringer_fitp" v-on:change="applyFilters"  ><label
                            for="ctr_pf_fitp_1">1° Grado</label></p>
                            <p class="remember-label"><input type="checkbox" name="tennis_cert_stringer_fitp" id="ctr_pf_fitp_2" value="2" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_stringer_fitp" v-on:change="applyFilters"  ><label
                            for="ctr_pf_fitp_2">2° Grado</label></p>
                        </div>

                        <div class="d-flex w-100 pt-2" >
                            <span class="tp-head d-flex align-items-center gap-5">
                                <!-- <img src="/img/website/favicon.png" width="20px" />  -->
                                <span class="c-title"><b>IRSA</b></span>
                             </span>
                        </div>
                        <div class="pf-field ps-2" >
                            <p class="remember-label"><input type="checkbox" name="tennis_cert_stringer_irsa" id="ctr_inc_1" value="1" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_stringer_irsa" v-on:change="applyFilters"  ><label
                                    for="ctr_inc_1">IRSA Stringer</label></p>
                            <p class="remember-label"><input type="checkbox" name="tennis_cert_stringer_irsa" id="ctr_inc_2" value="2" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_stringer_irsa" v-on:change="applyFilters"  ><label
                                    for="ctr_inc_2">Pro Stringer</label></p>
                            <p class="remember-label"><input type="checkbox" name="tennis_cert_stringer_irsa" id="ctr_inc_3" value="3" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_stringer_irsa" v-on:change="applyFilters"  ><label
                                    for="ctr_inc_3">Tournament Stringer</label></p>
                            <p class="remember-label"><input type="checkbox" name="tennis_cert_stringer_irsa" id="ctr_inc_4" value="4" v-on:focus="clearErrors" v-model="filter_certifications.tennis_cert_stringer_irsa" v-on:change="applyFilters"  ><label
                                    for="ctr_inc_4">Racquet Technician</label></p>
                        </div>
                    </div>
                </div>


            </div>

            <!-- Padel -->
            <div class="padel-certification-wrapper">

                <!-- Maestro di padel -->
                <div class="certification-filter-group" v-if="filter_roles.includes('6')">
                    <span class="tp-head filter-group-head">Maestro di padel</span>
                    <div class="certification-filter-inner">
                        <div class="d-flex">
                            <span class="tp-head d-flex align-items-center gap-5">
                                <!-- <img src="/img/website/favicon.png" width="20px" />  -->
                                <span class="c-title"><b>FITP</b></span>
                            </span>
                        </div>
                        <div class="pf-field ps-2">
                            <p class="remember-label">
                                <input type="checkbox" name="padel_cert_coach_fitp" id="padel_cert_coach_fitp_1" value="1" v-on:focus="clearErrors" v-model="filter_certifications.padel_cert_coach_fitp" v-on:change="applyFilters" >
                                <label for="padel_cert_coach_fitp_1">1° Livello</label></p>
                            <p class="remember-label">
                                <input type="checkbox" name="padel_cert_coach_fitp" id="padel_cert_coach_fitp_2" value="2" v-on:focus="clearErrors" v-model="filter_certifications.padel_cert_coach_fitp" v-on:change="applyFilters" >
                                <label for="padel_cert_coach_fitp_2">2° Livello</label></p>
                        </div>
                        <div class="d-flex w-100 pt-2" >
                            <span class="tp-head d-flex align-items-center gap-5">
                                <!-- <img src="/img/website/favicon.png" width="20px" />  -->
                                <span class="c-title"><b>PTR</b></span>
                            </span>
                        </div>
                        <div class="pf-field ps-2">
                            <p class="remember-label">
                                <input type="checkbox" name="padel_cert_coach_ptr" id="padel_cert_coach_ptr_1" value="1" v-on:focus="clearErrors" v-model="filter_certifications.padel_cert_coach_ptr" v-on:change="applyFilters" >
                                <label for="padel_cert_coach_ptr_1">Associate Instructor</label></p>
                            <p class="remember-label">
                                <input type="checkbox" name="padel_cert_coach_ptr" id="padel_cert_coach_ptr_2" value="2" v-on:focus="clearErrors" v-model="filter_certifications.padel_cert_coach_ptr" v-on:change="applyFilters" >
                                <label for="padel_cert_coach_ptr_2">Instructor</label></p>
                            <p class="remember-label">
                                <input type="checkbox" name="padel_cert_coach_ptr" id="padel_cert_coach_ptr_3" value="3" v-on:focus="clearErrors" v-model="filter_certifications.padel_cert_coach_ptr" v-on:change="applyFilters">
                                <label for="padel_cert_coach_ptr_3">Professional</label></p>
                        </div>
                       
                    </div>
                </div>

            </div>
        </section>


        <section class="search-filter-group classification-filter mt-4" v-if="filter_roles.includes('2') || filter_roles.includes('3') || filter_roles.includes('7')">
            <div class="filters-heading">
                <span class="form-section-title pf-title">Classifica FITP, fino a</span>
            </div>

            <!-- Classification wrapper -->
            <div class="classification-wrapper">

                <div class="certification-filter-group" v-if="filter_roles.includes('2') || filter_roles.includes('3') ">
                    <span class="tp-head filter-group-head">Tennis</span>
                    <div class="pf-field">
                        <select data-placeholder="" placeholder="Classifica FITP, fino a:"  v-on:focus="clearErrors" v-on:change="applyFilters"  name="tennis_classification_fitp_minimum_actual" v-model="filter_certifications.tennis_classification_fitp_minimum_actual">
                            <option value="" selected>Classifica FITP, fino a:</option>
                            <option v-for="(op, index) in tcfitp_minimum_actual_options" :key="index" :value="op">{{ op }}</option>
                            <!-- <option key="tennis_classification_fitp_minimum_actual_classifica" value="Classifica" :selected="true" >Classifica</option> -->
                        </select>
                    </div>
                </div>

                <div class="certification-filter-group" v-if="filter_roles.includes('7')">
                    <span class="tp-head filter-group-head">Padel</span>
                    <div class="pf-field">
                        <select data-placeholder="" placeholder="Classifica FITP, fino a:"  v-on:focus="clearErrors" v-on:change="applyFilters"  name="padel_classification_fitp_minimum_actual" v-model="filter_certifications.tennis_classification_fitp_minimum_actual ">
                            <option value="" selected>Classifica FITP, fino a:</option>
                            <option v-for="(op, index) in pcfitp_minimum_actual_options" :key="index" :value="op">{{ op }}</option>
                            <!-- <option key="tennis_classification_fitp_minimum_actual_classifica" value="Classifica" :selected="true" >Classifica</option> -->
                        </select>
                    </div>
                </div>

            </div>
        </section>




        <div class="filters-clear-wrapper mt-4" :class="{'show-filter': this.show_clear_filter}" >
            <a class="pf-text-link" href="#" @click="handleClearFilter"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 348.333 348.333" class="vue-treeselect__x" style="color: #A4CC5E;fill: #A4CC5E;"><path d="M336.559 68.611L231.016 174.165l105.543 105.549c15.699 15.705 15.699 41.145 0 56.85-7.844 7.844-18.128 11.769-28.407 11.769-10.296 0-20.581-3.919-28.419-11.769L174.167 231.003 68.609 336.563c-7.843 7.844-18.128 11.769-28.416 11.769-10.285 0-20.563-3.919-28.413-11.769-15.699-15.698-15.699-41.139 0-56.85l105.54-105.549L11.774 68.611c-15.699-15.699-15.699-41.145 0-56.844 15.696-15.687 41.127-15.687 56.829 0l105.563 105.554L279.721 11.767c15.705-15.687 41.139-15.687 56.832 0 15.705 15.699 15.705 41.145.006 56.844z"></path></svg>  <span>Cancella tutto</span></a>
        </div>

    </div>
  </template>
  
  <script>
  import Treeselect from '@zanmato/vue3-treeselect';
  // CSS import moved to app.js for proper loading order
  import { EventBus } from '../event-bus';

  export default {
    name: 'search-ad-filters',
    emits: ['filters-applied'],
    props: {
       
       // Options
       tcfitp_minimum_actual_options: {
        type: Array, 
        required: false,
        default: function(){
            return ['4 N.C.','4.6','4.5','4.4','4.3','4.2','4.1','3.5','3.4','3.3','3.2','3.1','2.8','2.7','2.6','2.5','2.4','2.3','2.2','2.1','1.20','1.19','1.18','1.17','1.16','1.15','1.14','1.13','1.12','1.11','1.10','1.9','1.8','1.7','1.6','1.5','1.4','1.3','1.2','1.1'];
        }
       },
       pcfitp_minimum_actual_options: {
        type: Array, 
        required: false,
        default: function(){
            return ['4 N.C.','4.4','4.3','4.2','4.1','3.4','3.3','3.2','3.1','2.4','2.3','2.2','2.1','1.2','1.1'];
        }
       },

       certification_mapping: {
        type: Object,
        required: false, 
        default: function(){
            const certificationMapping = {
                '1': [ // Maestro di tennis
                    'tennis_cert_coach_sparring_fitp',
                    'tennis_cert_coach_sparring_ptr',
                    'tennis_cert_coach_sparring_mtmca',
                    'tennis_cert_physicaltrainer_fitp',
                    'tennis_cert_stringer_fitp',
                    'tennis_cert_stringer_irsa',
                ],
                '2': ['tennis_classification_fitp_minimum_actual'], // Sparring partner
                '4': ['tennis_cert_physicaltrainer_fitp'], // Preparatore fisico
                '5': ['tennis_cert_stringer_fitp', 'tennis_cert_stringer_irsa'], // Incordatore
                '3': ['tennis_classification_fitp_minimum_actual'], // Giocatore di tennis
                '6': ['padel_cert_coach_fitp', 'padel_cert_coach_ptr'], // Maestro di padel
                '7': ['padel_classification_fitp_minimum_actual'] // Giocatore di padel
            };

            return certificationMapping;
        }
       },

       addressmaster: {
        type: Array, 
        required: true,
        default: function(){
            return [];
        }
       },

       abroad_only_text: {
        type: String,
        required: false, 
        default: 'All\'estero'
       }
       
    },
    components: {
        Treeselect
    },
    data() {
      return {
        filter_provinces: [], // Includes provinces and regions in as flattened
        filter_roles: [],
        filter_abroad_only: false,
        filter_certifications: {

            // Tennis
            tennis_cert_coach_sparring_ptr: [],
            tennis_cert_coach_sparring_fitp: [],
            tennis_cert_coach_sparring_mtmca: [],
            tennis_cert_physicaltrainer_fitp: [],
            tennis_cert_stringer_fitp: [],
            tennis_cert_stringer_irsa: [],
            tennis_classification_fitp_minimum_actual: '',

            // Padel
            padel_classification_fitp_minimum_actual: '',
            padel_cert_coach_fitp: [],
            padel_cert_coach_ptr: []

        },
        // Add more filter data properties as needed
        
        // Business filter
        filter_business_id: null,

        // Provinces
        provinces: this.getAddressMaster(),
        // Utility
        filter_provinces_options: this.getAddressMaster(),
        show_clear_filter: false,

        // Page Data
        perPage: 10,
        page: 1,

      };
    },
    created() {
        let _this = this;

        // If URL contains filter params then refresh it
        this.parseURLParams();

        // Listen for popstate event to handle history changes
        window.addEventListener('popstate', () => {
            // When the event is triggered (history state change), call parseURLParams()
            this.parseURLParams();
            this.applyFilters();
            console.log('popstate event called;');
        });
    },
    mounted() {
        this._filtersApplyHandler = (payload) => {
            // Update the page and perPage value
            console.log( 'Event Bus Filter event:', payload );
            if ( payload && payload.page && payload.perPage ) {
                this.perPage = payload.perPage ? payload.perPage : this.perPage;
                this.page = payload.page ? payload.page : this.page;
                console.log('Event Bus Filters Apply: ', payload);
                console.log( 'Filter component data: ', this.perPage, this.page );
            }

            this.applyFilters( null, this.page, this.perPage );
        };

        EventBus.$on('filtersApply', this._filtersApplyHandler);

        // Search Ads filter event
        document.addEventListener('professionalApplicationSubmitted', function(event) {
            // Handle the event

            let ad_id = event?.detail?.ad_id;
            console.log( event.detail );
            if ( ad_id ) {
                // _this.applyFilters();
            }

        });
    },

    beforeUnmount() {
        if (this._filtersApplyHandler) {
            EventBus.$off('filtersApply', this._filtersApplyHandler);
        }
    },

    methods: {
      applyFilters( event, pageNumber, perPage  ) {

        // Initiate tooltips
        if ( $ ) {
            window.setTimeout(function(){
                jQuery(".entry-item-inner [data-bs-toggle='tooltip']").tooltip('dispose')                 
                jQuery(".entry-item-inner [data-bs-toggle='tooltip']").tooltip();
            }, 500);
        }

        // Implement logic to apply filters

        // Clear provinces if abroad only is ticked
        if ( this.filter_abroad_only ) {
            this.filter_provinces = []; // clear it out
        }

        // Parse the provinces
        console.log('apply filters page ', pageNumber, perPage);
        let getProvincesRegions = this.getProvincesFromRegion();

        // Update the show_clear_filter value
        if ( this.filter_provinces.length || this.filter_roles.length || this.filter_abroad_only ) {
            this.show_clear_filter = true;
        } else {
            this.show_clear_filter = false;
        }

        // Reset the page number
        this.page = pageNumber ? pageNumber : 1;
        this.perPage = perPage ? perPage : this.perPage;


        // Certification to role mapping
        // Mapping between filter_roles and filter_certifications entries
        

        // For example, you can emit an event to notify the parent component
        /*
        let parsed_filter_certifications = Object.fromEntries(
            Object.entries(this.filter_certifications).filter(([key, value]) => {
                return (
                (Array.isArray(value) && value.length > 0) ||
                (typeof value === 'string' && value !== '')
                );
            })
            .filter(([key]) => this.filter_roles.includes(key)) // Filter based on filter_roles
            .flatMap(([key, _]) => certificationMapping[key].map(cert => [cert, this.filter_certifications[cert]]))
            .filter(([_, value]) => (
                (Array.isArray(value) && value.length > 0) ||
                (typeof value === 'string' && value !== '')
            ))
        );
        */
       // Filter and map filter_certifications based on filter_roles
        let parsed_filter_certifications = {};
        
        Object.keys(this.certification_mapping).forEach(role => {
            if (this.filter_roles?.includes(role)) {
                this.certification_mapping[role].forEach(cert => {
                    const value = this.filter_certifications[cert];
                    if (
                        (Array.isArray(value) && value.length > 0) ||
                        (typeof value === 'string' && value !== '')
                    ) {
                        if (Array.isArray(value) && value.length > 0) {
                            parsed_filter_certifications[cert] = value;
                        } else if (typeof value === 'string' && value !== '') {
                            parsed_filter_certifications[cert] = value;
                        } else {
                            if ( cert === 'tennis_classification_fitp_minimum_actual' || cert === 'padel_classification_fitp_minimum_actual' ) {
                                parsed_filter_certifications[cert] = '';
                            }
                        }
                    }
                });
            }
        });
        
       
        


        console.log( 'parsed filters certifications: ', parsed_filter_certifications );
        console.log( 'filter roles: ', this.filter_roles );




        const filter_data = {
          // send the payload here
          provinces: this.filter_abroad_only ? [] : getProvincesRegions?.provinces, // provinces data
          roles: this.filter_roles,
          abroad_only: this.filter_abroad_only,
          // certifications: this.filter_certifications,
          certifications: parsed_filter_certifications,
          page: this.page,
          perPage: this.perPage,
          business_id: this.filter_business_id, // Add business_id filter
        };

        // Emit the data to the parent component
        this.$emit('filters-applied', filter_data);

        // Apply it to a global variable
        window['search_ads_filter'] = filter_data;

        // Create a custom event with data
        const eventData = { filter_data };


        /*
        const customEvent = new CustomEvent('filtersApplied', { detail: eventData });
        // Dispatch the event
        document.dispatchEvent(customEvent);
        */

        EventBus.$emit('filtersApplied', eventData);
        console.log('Filters applied event emitted:', eventData);   

        // Update the browser URL using history pushState
        console.log( 'Per page & page', this.perPage, this.page );
        this.updateFilterURL();


        // Send the Gtag event for search
        if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
            window.gtag('event', 'search', {
                search_term: JSON.stringify(filter_data)
            });
        }

        
      },

      // Apply province / region filter
      applyProvinceRegion(){
        this.applyFilters();
      },

      // Updates the filter URL upon applying filters
      updateFilterURL() { 
            const urlParams = new URLSearchParams();

            // Update query parameters based on filter_provinces and filter_roles
            this.filter_provinces.forEach(province => {
                urlParams.append('filter-provinces', province);
            });

            this.filter_roles.forEach(role => {
                urlParams.append('filter-roles', role);
            });

            // Add business_id to URL if it exists
            if ( this.filter_business_id ) {
                urlParams.append('business_id', this.filter_business_id);
            }

            // For pagination
            if ( this.page ) {
                urlParams.append('page', this.page);
            }

            if ( this.perPage ) {
                urlParams.append('perPage', this.perPage);
            }
            
            // Abroad only
            if ( this.filter_abroad_only ) {
                urlParams.append('abroad-only', this.filter_abroad_only);
            }

            // Update query parameters based on filter_certifications
            for (const cert in this.filter_certifications) {
                const value = this.filter_certifications[cert];

                let includeCert = false;

                Object.keys(this.certification_mapping).forEach(role => {
                    if (this.certification_mapping[role].includes(cert) && this.filter_roles.includes(role)) {
                        includeCert = true;
                    }
                });

                if (
                    includeCert &&
                    (
                        (cert === 'tennis_classification_fitp_minimum_actual' || cert === 'padel_classification_fitp_minimum_actual') ||
                        (Array.isArray(value) && value.length > 0)
                    )
                ) {
                    if (Array.isArray(value)) {
                        value.forEach(val => {
                            urlParams.append(cert, val);
                        });
                    } else if (value !== '') {
                        urlParams.append(cert, value);
                    }
                }
            }

            // Construct the URL with the updated parameters
            const newURL = `${window.location.pathname}?${urlParams.toString()}`;

            // Push the new URL to the browser history
            history.pushState({}, '', newURL);
      },


      // Parsed the filters in the url and sets its data
      parseURLParams() {
        const urlParams = new URLSearchParams(window.location.search);

        // Extract query parameters for filter_provinces and filter_roles
        const filterProvincesParam = urlParams.getAll('filter-provinces');
        const filterRolesParam = urlParams.getAll('filter-roles');
        const businessIdParam = urlParams.get('business_id'); // Get business_id from URL

        // Update component data with URL parameters
        this.filter_provinces = filterProvincesParam.length ? filterProvincesParam : [];
        this.filter_roles = filterRolesParam ? filterRolesParam : [];
        this.filter_business_id = businessIdParam ? parseInt(businessIdParam) : null; // Set business_id filter

        // For pagination
        const perPage = urlParams.getAll('perPage');
        const page = urlParams.getAll('page');
        const abroadOnly = urlParams.getAll('abroad-only');
        this.perPage = perPage ? perPage[0] : this.perPage;
        this.page = page ? page[0] : this.page;
        this.filter_abroad_only = abroadOnly[0] == 'true' ? true : false;

        // Extract and update filter_certifications properties using URL parameters
        for (const cert in this.filter_certifications) {
            const certParam = urlParams.getAll(cert);

            // Check if the parameter exists and update the corresponding property
            if (certParam.length > 0) {
                const filteredParams = certParam.filter(param => param !== 'false'); // Exclude 'false' values
                if (filteredParams.length > 0) {
                    if (cert === 'tennis_classification_fitp_minimum_actual' || cert === 'padel_classification_fitp_minimum_actual') {
                        this.filter_certifications[cert] = filteredParams.length === 1 ? filteredParams[0] : filteredParams[0];
                    } else {
                        this.filter_certifications[cert] = filteredParams.length === 1  ? filteredParams : filteredParams;
                    }
                } else {
                    if (cert === 'tennis_classification_fitp_minimum_actual' || cert === 'padel_classification_fitp_minimum_actual') {
                        this.filter_certifications[cert] = '';
                    } else {
                        this.filter_certifications[cert] = [];
                    }
                 }
            } else {
                if (cert === 'tennis_classification_fitp_minimum_actual' || cert === 'padel_classification_fitp_minimum_actual') {
                    this.filter_certifications[cert] = '';
                } else {
                    this.filter_certifications[cert] = [];
                }
            }
        }

        // Now your component's data should be updated based on the URL parameters
        
      },

      handleClearFilter() {

        // Clear the filters data
        this.filter_provinces = [];
        this.filter_roles = [];
        this.filter_abroad_only = false;
        this.filter_certifications = {
            // Tennis
            tennis_cert_coach_sparring_ptr: [],
            tennis_cert_coach_sparring_fitp: [],
            tennis_cert_coach_sparring_mtmca: [],
            tennis_cert_physicaltrainer_fitp: [],
            tennis_cert_stringer_fitp: [],
            tennis_cert_stringer_irsa: [],
            tennis_classification_fitp_minimum_actual: '',

            // Padel
            padel_classification_fitp_minimum_actual: '',
            padel_cert_coach_fitp: [],
            padel_cert_coach_ptr: []
        };

        this.applyFilters();

      },

      clearErrors() {
        // do nothing..
      },

      getProvincesFromRegion(){
            let arrayOfRegions = this.filter_provinces;

            let regions = [];
            let provinces = [];

            if ( typeof arrayOfRegions == 'object' ) {
                for ( let i = 0; i < arrayOfRegions.length; i++ ) {
                
                    let foundItems = this.provinces.filter(item => item.id === arrayOfRegions[i]);

                    if ( foundItems.length ) {
                        regions.push( arrayOfRegions[i] );
                        foundItems[0].children.map( ( province )=> {
                            provinces.push( province.id );
                        });
                    } else {
                        provinces.push( arrayOfRegions[i] );
                    }
                }
            }

            // console.log( 'List of regions / provinces: ', { regions, provinces } );

            return { regions, provinces };
      },

      getAddressMaster(){
        const transformedData = [];
        // let data = [{"region": "Abruzzo", "province": "L'Aquila"}, {"region": "Abruzzo", "province": "Chieti"}, {"region": "Abruzzo", "province": "Pescara"}, {"region": "Abruzzo", "province": "Teramo"}, {"region": "Basilicata", "province": "Matera"}, {"region": "Basilicata", "province": "Potenza"}, {"region": "Calabria", "province": "Catanzaro"}, {"region": "Calabria", "province": "Cosenza"}, {"region": "Calabria", "province": "Crotone"}, {"region": "Calabria", "province": "Reggio Calabria"}, {"region": "Calabria", "province": "Vibo Valentia"}, {"region": "Campania", "province": "Avellino"}, {"region": "Campania", "province": "Benevento"}, {"region": "Campania", "province": "Caserta"}, {"region": "Campania", "province": "Napoli"}, {"region": "Campania", "province": "Salerno"}, {"region": "Emilia Romagna", "province": "Bologna"}, {"region": "Emilia Romagna", "province": "Ferrara"}, {"region": "Emilia Romagna", "province": "Forlì Cesena"}, {"region": "Emilia Romagna", "province": "Modena"}, {"region": "Emilia Romagna", "province": "Parma"}, {"region": "Emilia Romagna", "province": "Piacenza"}, {"region": "Emilia Romagna", "province": "Ravenna"}, {"region": "Emilia Romagna", "province": "Reggio Emilia"}, {"region": "Emilia Romagna", "province": "Rimini"}, {"region": "Friuli Venezia Giulia", "province": "Gorizia"}, {"region": "Friuli Venezia Giulia", "province": "Pordenone"}, {"region": "Friuli Venezia Giulia", "province": "Trieste"}, {"region": "Friuli Venezia Giulia", "province": "Udine"}, {"region": "Lazio", "province": "Frosinone"}, {"region": "Lazio", "province": "Latina"}, {"region": "Lazio", "province": "Rieti"}, {"region": "Lazio", "province": "Roma"}, {"region": "Lazio", "province": "Viterbo"}, {"region": "Liguria", "province": "Genova"}, {"region": "Liguria", "province": "Imperia"}, {"region": "Liguria", "province": "La Spezia"}, {"region": "Liguria", "province": "Savona"}, {"region": "Lombardia", "province": "Bergamo"}, {"region": "Lombardia", "province": "Brescia"}, {"region": "Lombardia", "province": "Como"}, {"region": "Lombardia", "province": "Cremona"}, {"region": "Lombardia", "province": "Lecco"}, {"region": "Lombardia", "province": "Lodi"}, {"region": "Lombardia", "province": "Mantova"}, {"region": "Lombardia", "province": "Milano"}, {"region": "Lombardia", "province": "Monza Brianza"}, {"region": "Lombardia", "province": "Pavia"}, {"region": "Lombardia", "province": "Sondrio"}, {"region": "Lombardia", "province": "Varese"}, {"region": "Marche", "province": "Ancona"}, {"region": "Marche", "province": "Ascoli Piceno"}, {"region": "Marche", "province": "Fermo"}, {"region": "Marche", "province": "Macerata"}, {"region": "Marche", "province": "Pesaro Urbino"}, {"region": "Molise", "province": "Campobasso"}, {"region": "Molise", "province": "Isernia"}, {"region": "Piemonte", "province": "Alessandria"}, {"region": "Piemonte", "province": "Asti"}, {"region": "Piemonte", "province": "Biella"}, {"region": "Piemonte", "province": "Cuneo"}, {"region": "Piemonte", "province": "Novara"}, {"region": "Piemonte", "province": "Torino"}, {"region": "Piemonte", "province": "Verbania"}, {"region": "Piemonte", "province": "Vercelli"}, {"region": "Puglia", "province": "Bari"}, {"region": "Puglia", "province": "Barletta Andria Trani"}, {"region": "Puglia", "province": "Brindisi"}, {"region": "Puglia", "province": "Foggia"}, {"region": "Puglia", "province": "Lecce"}, {"region": "Puglia", "province": "Taranto"}, {"region": "Sardegna", "province": "Cagliari"}, {"region": "Sardegna", "province": "Nuoro"}, {"region": "Sardegna", "province": "Sud Sardegna"}, {"region": "Sardegna", "province": "Oristano"}, {"region": "Sardegna", "province": "Sassari"}, {"region": "Sicilia", "province": "Agrigento"}, {"region": "Sicilia", "province": "Caltanissetta"}, {"region": "Sicilia", "province": "Catania"}, {"region": "Sicilia", "province": "Enna"}, {"region": "Sicilia", "province": "Messina"}, {"region": "Sicilia", "province": "Palermo"}, {"region": "Sicilia", "province": "Ragusa"}, {"region": "Sicilia", "province": "Siracusa"}, {"region": "Sicilia", "province": "Trapani"}, {"region": "Toscana", "province": "Arezzo"}, {"region": "Toscana", "province": "Firenze"}, {"region": "Toscana", "province": "Grosseto"}, {"region": "Toscana", "province": "Livorno"}, {"region": "Toscana", "province": "Lucca"}, {"region": "Toscana", "province": "Massa Carrara"}, {"region": "Toscana", "province": "Pisa"}, {"region": "Toscana", "province": "Pistoia"}, {"region": "Toscana", "province": "Prato"}, {"region": "Toscana", "province": "Siena"}, {"region": "Trentino Alto Adige", "province": "Bolzano"}, {"region": "Trentino Alto Adige", "province": "Trento"}, {"region": "Umbria", "province": "Perugia"}, {"region": "Umbria", "province": "Terni"}, {"region": "Valle d'Aosta", "province": "Aosta"}, {"region": "Veneto", "province": "Belluno"}, {"region": "Veneto", "province": "Padova"}, {"region": "Veneto", "province": "Rovigo"}, {"region": "Veneto", "province": "Treviso"}, {"region": "Veneto", "province": "Venezia"}, {"region": "Veneto", "province": "Verona"}, {"region": "Veneto", "province": "Vicenza"}];
        let data = this.addressmaster;

        data.forEach(item => {
            const regionIndex = transformedData.findIndex(entry => entry.id === item.region);

            if (regionIndex === -1) {
                transformedData.push({
                    id: item.region,
                    label: item.region,
                    children: [{ id: item.province, label: `${item.province} (${item.province_code})` }]
                });
            } else {
                transformedData[regionIndex].children.push({ id: item.province, label: `${item.province} (${item.province_code})` });
            }
        });

        return transformedData;
      }

    },
  };
  </script>
  
  <style scoped>
  /* Add your component-specific styles here */
  </style>
  
